import { isEqual } from 'lodash';

import { GRID_LIST_VIEW_TYPE } from '../types';

const isCategoryView = (viewSetting: GRID_LIST_VIEW_TYPE): boolean =>
  isEqual(viewSetting, GRID_LIST_VIEW_TYPE.CATEGORY_VIEW);

export { isCategoryView };
